import {
  createStyles,
  makeStyles,
} from '@mui/styles';
import { Theme, } from '@mui/material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: '10px',
    },
    img: {
      width: '19%',
    },
    inline: {
      margin: theme.spacing(1),
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    paddingBox: {
      paddingBottom: '15px',
    },
    button: {
      margin: theme.spacing(1),
    },
    treeBox: {
      border: '1px solid #c0c0c0',
      borderRadius: '5px',
      overflowY: 'auto',
      height: '77%',
    },
    buttonTest: {
      float: 'right',
      margin: '8px',
    },
    treeBoxEmpty: {
      textAlign: 'center',
      border: '1px solid #c0c0c0',
      borderRadius: '5px',
      overflowY: 'auto',
      minHeight: '250px',
      paddingTop: 100,
      marginBottom: 15,
    },
    exploreButton: {
      height: 50,
      width: 120,
      fontSize: '1.2rem',
    },
  })
);

export default useStyles;
